import React from 'react';
import { 
  TrendingUp, 
  Smartphone, 
  Award, 
  ShieldCheck, 
  Target, 
  BarChart3,
  LineChart,
  DollarSign
} from 'lucide-react';

const SectionTitle = ({ subtitle, title, align = 'left' }) => (
  <div className={`mb-12 ${align === 'center' ? 'text-center' : ''}`}>
    <div className={`flex items-center gap-2 mb-3 ${align === 'center' ? 'justify-center' : ''}`}>
      <div className="w-12 h-0.5 bg-[#F49611]"></div>
      <span className="text-[#F49611] font-medium uppercase tracking-wider text-sm">{subtitle}</span>
    </div>
    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">{title}</h2>
  </div>
);

const ApproachCard = ({ Icon, title, description, index }) => (
  <div className="group">
    <div className="relative p-8 rounded-xl bg-white border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
      <div className="absolute top-0 right-0 w-24 h-24 bg-[#E8EEF6] rounded-bl-full -z-10 group-hover:bg-[#F49611] transition-colors duration-300"></div>
      <div className="flex items-start gap-6">
        <div className="relative">
          <div className="w-12 h-12 rounded-xl bg-[#E8EEF6] group-hover:bg-[#F49611] transition-colors duration-300 flex items-center justify-center">
            <Icon className="w-6 h-6 text-[#113262] group-hover:text-white transition-colors duration-300" />
          </div>
          <span className="absolute -bottom-4 -right-4 text-4xl font-bold text-[#E8EEF6] group-hover:text-[#F49611]/10 transition-colors duration-300">
            {String(index).padStart(2, '0')}
          </span>
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-[#113262] mb-3">{title}</h3>
          <p className="text-gray-600">{description}</p>
        </div>
      </div>
    </div>
  </div>
);


const MainContent = () => {
  return (
    <div className="space-y-32">
      {/* Features Section */}
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-12">
        <SectionTitle
          subtitle="Our Approach"
          title="How our unique approach benefit your child"
        />
        <div className="grid md:grid-cols-2 gap-8">
          {[
            {
              icon: TrendingUp,
              title: "Deep Expertise",
              description: "With vast knowledge in stocks and mutual funds, we offer sound investment advice for your child's future."
            },
            {
              icon: Smartphone,
              title: "Integrated Platform",
              description: "Our web and mobile app streamlines financial planning, execution, and tracking for family needs."
            },
            {
              icon: Award,
              title: "Certified Processes",
              description: "ISO 9001 certified, ensuring quality in financial and investment planning tailored for childbirth."
            },
            {
              icon: ShieldCheck,
              title: "Fiduciary Role",
              description: "As SEBI registered advisors, our allegiance lies solely with our clients, ensuring unbiased advice."
            },
            {
              icon: Target,
              title: "Goal-Oriented",
              description: "Our unique approach aligns all assets and investment plans to your child's future goals."
            },
            {
              icon: LineChart,
              title: "No Third-Party Bias",
              description: "With a proprietary data analytics platform, we offer insights based purely on merit, not external influences."
            }
          ].map((approach, index) => (
            <ApproachCard
              key={index}
              Icon={approach.icon}
              title={approach.title}
              description={approach.description}
              index={index + 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MainContent;